// extracted by mini-css-extract-plugin
export default {"title":"TransportScreen_title__5j4qW","mainDiv":"TransportScreen_mainDiv__9IsBS"};